import React from 'react';
import './index.css';
import styled from '@emotion/styled';
import { NavLink, Outlet } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import PlusButton from './components/PlusButton';

const StyledSidebar = styled.div`
  // 5% opacity
  background-color: ${props => props.theme.colors.gray + '0D'};
  width: 296px;
  padding: 8px;
  display:flex;
  flex-direction:column;
  border-radius: 16px;
`;

const SidebarScroller = styled.div`
  padding: 8px;
  display:flex;
  flex-direction:column;
  overflow-y: auto;
  overflow-x: hidden;
`; 

const StyledNavLink = styled(NavLink)`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 1px;
  display: flex;
  width: 100%;
  padding: 10px 16px;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  &.active {
    // .15 opacity
    background-color: ${props => props.theme.colors.primaryColor + '26'};
  }
`;

const mockBoardList = [
  {
    id: uuidv4(),
    title: 'Project Alpha',
  },
  {
    id: uuidv4(),
    title: 'Marketing Campaign',
  },
  {
    id: uuidv4(),
    title: 'Product Launch',
  },
  {
    id: uuidv4(),
    title: 'Team Building',
  },
  {
    id: uuidv4(),
    title: 'Client Onboarding',
  },
  {
    id: uuidv4(),
    title: 'Board 6',
  },
  {
    id: uuidv4(),
    title: 'Board 7',
  },
  {
    id: uuidv4(),
    title: 'Board 8',
  },
  {
    id: uuidv4(),
    title: 'Board 9',
  },
  {
    id: uuidv4(),
    title: 'Board 10',
  },
  {
    id: uuidv4(),
    title: 'Board 11',
  },
  {
    id: uuidv4(),
    title: 'Board 12',
  },
  {
    id: uuidv4(),
    title: 'Board 13',
  },
  {
    id: uuidv4(),
    title: 'Board 14',
  },
  {
    id: uuidv4(),
    title: 'Board 15',
  },
  {
    id: uuidv4(),
    title: 'Board 16',
  },
];

export default function PlannerPage() {
  return (
    <div className="planner-section">
      <StyledSidebar>
        <SidebarScroller className='u-fancy-scrollbar' >
        <div className='planner-sidebar-top'>
          <div className='planner-title'>Доски</div>
          <PlusButton />
        </div>
        {
          mockBoardList.map(board => (
            <StyledNavLink to={`/collaborations/planner/${board.id}`} key={board.id}>
              {board.title}
            </StyledNavLink>
          ))
        }
        </SidebarScroller>
      </StyledSidebar>
      <Outlet />
    </div>
  );
}